
import React from 'react';
import type { LayoutProps } from '../types';

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-slate-900 text-slate-200 flex flex-col font-sans">
      <header className="bg-slate-800/50 backdrop-blur-sm shadow-lg border-b border-slate-700 sticky top-0 z-10">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center space-x-3">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-indigo-400" viewBox="0 0 20 20" fill="currentColor">
                <path d="M10 3.5a1.5 1.5 0 011.126.432l5.001 4.5a1.5 1.5 0 010 2.136l-5.001 4.5A1.5 1.5 0 0110 16.5v-3.418a.5.5 0 00-.354-.47l-2.02-1.01a.5.5 0 010-.884l2.02-1.01A.5.5 0 0010 9.236V5.5a1.5 1.5 0 010-2z" />
                <path fillRule="evenodd" d="M3.5 6A1.5 1.5 0 015 4.5h3.25a.75.75 0 010 1.5H5A.5.5 0 004.5 7v6a.5.5 0 00.5.5h3.25a.75.75 0 010 1.5H5A1.5 1.5 0 013.5 13V6z" clipRule="evenodd" />
              </svg>
              <h1 className="text-2xl font-bold tracking-tight text-white">
                StoryShot <span className="text-indigo-400">AI</span>
              </h1>
            </div>
          </div>
        </div>
      </header>

      <main className="flex-grow container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>

      <footer className="bg-slate-800/50 border-t border-slate-700 mt-auto">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 text-center text-sm text-slate-400">
          <p>&copy; {new Date().getFullYear()} StoryShot AI. Powered by Google Gemini.</p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
